<div
  class="flex-fill d-flex flex-column justify-content-center align-items-center"
>
  <h3>
    Você vai ser direcionado para o site principal em
    {{ seconds$ | async }} segundos
  </h3>
  <a href="https://app.closecare.com.br">app.closecare.com.br</a>
</div>
